const PANEL_WIDTH = 1.15;
const PANEL_LENGTH = 2.5;
const HALF_PANEL_WIDTH = PANEL_WIDTH / 2;
const MAX_MANUFACTURER_PAIR_WIDTH = 0.6;
const EPSILON = 1e-9;
const PANEL_THICKNESS = 0.1;

const createWallPairPlan = (dimension, height) => {
    const fullStripsPerWall = Math.floor((dimension + EPSILON) / PANEL_WIDTH);
    const remainder = Math.max(0, dimension - fullStripsPerWall * PANEL_WIDTH);
    const heightSections = Math.ceil((height - EPSILON) / PANEL_LENGTH);
    const cutSheetsPerSection = remainder <= EPSILON
        ? 0
        : remainder <= MAX_MANUFACTURER_PAIR_WIDTH + EPSILON ? 1 : 2;
    const fullPanels = fullStripsPerWall * 2 * heightSections;
    const cutPanels = cutSheetsPerSection * heightSections;
    const cutPieces = cutPanels === 0 ? 0 : 2 * heightSections;
    return {
        panels: fullPanels + cutPanels,
        fullPanels,
        cutPanels,
        cutPieces,
        cutPieceWidth: cutSheetsPerSection === 0
            ? 0
            : cutSheetsPerSection === 1 ? HALF_PANEL_WIDTH : remainder,
        toleratedShortfall: cutSheetsPerSection === 1
            ? Math.max(0, remainder - HALF_PANEL_WIDTH)
            : 0,
    };
};

const createSurfacePlan = (shortSide, longSide) => {
    const fullColumns = Math.floor((longSide + EPSILON) / PANEL_WIDTH);
    const remainder = Math.max(0, longSide - fullColumns * PANEL_WIDTH);
    const cutColumns = remainder <= EPSILON ? 0 : 1;
    const lengthSections = Math.ceil((shortSide - EPSILON) / PANEL_LENGTH);
    const fullPanels = fullColumns * lengthSections;
    const cutPanels = cutColumns * lengthSections;
    return {
        panels: fullPanels + cutPanels,
        fullPanels,
        cutPanels,
        cutPieceWidth: cutColumns === 0
            ? 0
            : remainder <= HALF_PANEL_WIDTH + EPSILON ? HALF_PANEL_WIDTH : remainder,
    };
};

const getAreaMateriales = (panelCount) => panelCount * PANEL_WIDTH * PANEL_LENGTH;

export const calculateGabinetePanels = ({
    frente,
    profundidad,
    altura,
    precioM2 = 0,
    precioM3 = 0,
    precioDolar = 0,
    incluirPiso = false,
}) => {
    const frenteM = Number(frente) || 0;
    const profundidadM = Number(profundidad) || 0;
    const alturaM = Number(altura) || 0;
    const frontWalls = createWallPairPlan(frenteM, alturaM);
    const depthWalls = createWallPairPlan(profundidadM, alturaM);
    const shortSide = Math.min(frenteM, profundidadM);
    const longSide = Math.max(frenteM, profundidadM);
    const roof = createSurfacePlan(shortSide, longSide);
    const floor = createSurfacePlan(shortSide, longSide);

    const areaParedes = 2 * (frenteM + profundidadM) * alturaM;
    const areaTecho = frenteM * profundidadM;
    const areaPiso = frenteM * profundidadM;
    const areaInstalled = areaParedes + areaTecho + (incluirPiso ? areaPiso : 0);
    const volumeInstalled = areaInstalled * PANEL_THICKNESS;
    const totalPaneles = frontWalls.panels + depthWalls.panels + roof.panels
        + (incluirPiso ? floor.panels : 0);
    const areaMateriales = getAreaMateriales(totalPaneles);
    const areaWaste = Math.max(0, areaMateriales - areaInstalled);
    const panelSobrante = areaWaste * PANEL_THICKNESS;
    const volumenTotal = volumeInstalled;
    const volumenMateriales = areaMateriales * PANEL_THICKNESS;
    const precioMaterialEfectivoM2 = precioM2 === undefined || precioM2 === null || precioM2 === ""
        ? (Number(precioM3) || 0) * PANEL_THICKNESS
        : Number(precioM2) || 0;
    const costoSobrante = areaWaste * precioMaterialEfectivoM2 * (Number(precioDolar) || 0);
    const costoMateriales = areaMateriales * precioMaterialEfectivoM2 * (Number(precioDolar) || 0);

    return {
        frontWalls,
        depthWalls,
        roof,
        floor,
        totalPaneles,
        areaParedes,
        areaTecho,
        areaPiso,
        areaMateriales,
        areaWaste,
        volumenTotal,
        panelSobrante,
        volumenMateriales,
        costoSobrante,
        costoMateriales,
        panelWidth: PANEL_WIDTH,
        panelLength: PANEL_LENGTH,
    };
};
